import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError, notifyWarning } from '@/layouts/notifies'
import i18n from '@/i18n/i18n'

export default {
  createMetadata(context, metadataData) {
    return new Promise((resolve, reject) => {
      axios
        .post('metadata', metadataData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          if (error.response.status === 409) notifyWarning(i18n.t('server.error.request_already_metadataed'))
          else notifyServerError(error)
          reject(error)
        })
    })
  },
  countMetadata(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`metadata/count/?${query}`)
        .then(response => {
          context.commit('SET_METADATA_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchManyMetadata(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`metadata/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_METADATA', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchMetadata(context, metadataId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`metadata/${metadataId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeMetadata({ commit }, metadataId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`metadata/${metadataId}`)
        .then(response => {
          commit('REMOVE_RECORD', metadataId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editMetadata(context, metadata) {
    return new Promise((resolve, reject) => {
      axios
        .put(`metadata/${metadata.id}`, metadata.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editMetadataState(context, metadata) {
    return new Promise((resolve, reject) => {
      axios
        .put(`metadata/${metadata.id}/state`, metadata.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
